module.exports = __webpack_public_path__ + "static/media/card-email-es.7add6a3f.png";